import MiddleEllipsis from './middle-ellipsis';
export default MiddleEllipsis;
